module.exports = __webpack_public_path__ + "img/img1.f889c762.png";